import {Alert} from 'antd';

import {PageCard} from '../../../../../layout/page-card/page-card';
import {Locale} from '../../../../../provider/locale/locale';
import {useLocale} from '../../../../../provider/locale/locale-hook';
import {AiMonitoringConfigType} from '../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';
import {SettingsForm} from '../settings/settings-form';

import * as styles from './onboarding-view.scss';

type PropsType = {
    brandId: number;
    config: AiMonitoringConfigType;
};

export function OnboardingView(props: PropsType): JSX.Element {
    const {brandId, config} = props;
    const {getLocalizedString} = useLocale();

    return (
        <PageCard>
            <h2>
                <Locale stringKey="AI_BRAND_MONITORING__ONBOARDING__TITLE" />
            </h2>
            <p>
                <Locale stringKey="AI_BRAND_MONITORING__ONBOARDING__DESCRIPTION" />
            </p>
            {config.permissions.canManage ? null : (
                <Alert
                    className={styles.onboarding_view__alert}
                    description={getLocalizedString('AI_BRAND_MONITORING__ONBOARDING__NO_PERMISSION')}
                    showIcon
                    type="info"
                />
            )}
            <SettingsForm brandId={brandId} config={config} />
        </PageCard>
    );
}
